import { DocumentError, type DrawingDocument, type Layer } from './document';
import { isLayered, type LayerId, type NodeId } from './node';

export function getLayer(doc: DrawingDocument, id: LayerId): Layer | undefined {
  return doc.layers.find((layer) => layer.id === id);
}

export function requireLayer(doc: DrawingDocument, id: LayerId): Layer {
  const layer = getLayer(doc, id);
  if (!layer) throw new DocumentError(`No layer with id "${id}"`);
  return layer;
}

/** Whether a node may be in the selection: a group always, anything else on a shown, unlocked layer. */
export function isSelectable(doc: DrawingDocument, id: NodeId): boolean {
  const node = doc.nodes[id];
  if (!node) return false;
  if (!isLayered(node)) return true;
  const layer = getLayer(doc, node.layerId);
  return !layer || (layer.visible && !layer.locked);
}
